<template>
  <div>
  </div>
</template>

<script>
  import {MessageBox, Toast} from 'mint-ui'
  import session from '../utils/Session'
  import userService from '../service/customer/UserService'
  import {authUrl} from '../config'

  export default {
  name: 'Auth',
  data: function () {
    return {
    }
  },
  beforeMount () {
    this.auth();
  },
  methods: {
    async auth () {
      let code = this.$route.query.code;
      if(!code && !session.getOpenId()){
        let param = [];
        param.push('appid=wxd4718483b05d6d53');
        param.push('redirect_uri='+encodeURIComponent('https://xyz.shuimujiaju.com/callback/index_v2.html?v=1'));
        param.push('response_type=code');
        param.push('scope=snsapi_userinfo');
        // param.push('state=' + '{\'redirectUrl\': \''+ window.location.href +'\'}');
        param.push('state=' + encodeURIComponent(window.location.href));
        let redirectUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?' + param.join('&');
        window.location.href = redirectUrl;
      }else if(code){
        var result = await userService.getAccessToken(code);
        if (result.openId) {
          console.info(result.openId);
          var openId = result.openId || false;
          var unionId = result.unionId || false;
          session.unionId(unionId);
          session.nickname(result.nickname);
          session.avatar(result.headImgUrl);
          session.openId(openId);
          var result = await userService.checkWechatRegister(session.getUnionId(),openId);
          if(result.code == '0' && result.data.phone){
            session.phone(result.data.phone);
            this.loginByPhone(result.data.phone);
          }else {
            if(result.code == '0' && !result.data.phone){
              session.userType('2');
            }else {
              session.userType('1');
            }
            let backUrl = session.getBackUrl() || '';
            if(!backUrl){
              this.$router.push({name:'Index',params:{}});
            }else {
              this.$router.push(backUrl);
            }
          }

        }else {
          MessageBox.confirm('对不起，您的授权操作失败,请您重新授权!').then((action) => {
            window.location.href = authUrl;
          }).catch(e => {
            window.location = '/#/login'
          });
        }
      }else if(session.getUnionId()) {
        var result = await userService.checkWechatRegister(session.getUnionId(),session.getOpenId());
        if(result.code == '0' && result.data.phone){
          this.loginByPhone(result.data.phone);
        }else if(result.code == '0' && !result.data.phone){
          session.userType('2');
          this.$router.push({name:'BindPhone'});
        }else {
          session.userType('1');
          this.$router.push({name:'BindPhone'});
        }
      }
    },
    async loginByPhone(phone){
        let that = this;
        let res=await userService.phoneLogin(phone);
        if(res.code == '0'){
          session.accountToken(res.data);
          session.login(res.data);
          let backUrl = session.getBackUrl() || '';
          if(!backUrl){
            this.$router.push({name:'Home',params:{}});
          }else {
            this.$router.push(backUrl);
          }
        }else {
          Toast("登录失败，请稍后重试!");
        }
    },
    WxAuth(){
      this.$router.push({name:'Auth',params:{}});
    },
    //创建Nim
    newNim() {
      let that = this;
      console.log("查看是否支持数据库==================" + NIM.support.db)
      this.global.nim = NIM.getInstance({
        //控制台日志，上线时应该关掉
        debug: true || { api: 'info', style: 'font-size:14px;color:blue;background-color:rgba(0,0,0,0.1)' },
        appKey: window.CONFIG.appkey,

        //数据库
        db:true,
        //连接
        onconnect: that.onConnect.bind(this),
        ondisconnect: that.onDisconnect.bind(this),
        account: session.getAccountToken().openid,
//          account: 'helloworld',
        token: session.getEaseToken(),
//          token: 'cc1534508ef97a71851b211b3d97febe',
        // 会话
        onsessions: that.onSessions.bind(this),
        onupdatesession: that.onUpdateSession.bind(this),
        // 消息
        onroamingmsgs: that.onRoamingMsgs.bind(this),
        onofflinemsgs: that.onOfflineMsgs.bind(this),
        onmsg: that.onMsg.bind(this)
      });
      this.global.nim.connect();
    },
    onConnect(obj) {
      console.log('-------- onConnect', obj)
    },
    onDisconnect(obj) {
      console.log('--------- onDisconnect', obj)
    },
    onSessions(obj) {
      console.log('== Contact == onSessions() 方法,收到会话列表', obj)

      if (this.global.setContactList != null) {
        console.log('收到会话列表  this.global.setContactList != null')
        this.global.setContactList.setContact(obj);
      } else {
        console.log('收到会话列表  this.global.setContactList 为 null')
        let objList = [];
        for (let i = 0; i < obj.length; i ++) {
          if (obj[i].lastMsg.from.toLowerCase() != session.getAccountToken().openid.toLowerCase()) {
            objList.push(obj[i]);
          }
        }
        this.global.contactsList = objList;
      }
      this.countMsgNum();
    },
    onUpdateSession(obj) {
      let that = this;
      console.log('== Contact == onUpdateSession() 方法，会话列表更新  obj.lastMsg.from = ' + obj.lastMsg.from.toLowerCase() + "   session.getOpenId().toLowerCase() = " + session.getAccountToken().openid.toLowerCase(), obj)
      if (obj.lastMsg.from.toLowerCase() != session.getAccountToken().openid.toLowerCase()) {

        if (this.global.setContactList != null) {
          console.log('== Contact == onUpdateSession() 方法，会话列表更新  IF  ', obj)
          this.global.setContactList.pushContact(obj);
          console.log('== Contact == onUpdateSession() 方法，会话列表更新  this.global.contactsList  ', this.global.contactsList)
        } else {
          console.log('== Contact == onUpdateSession() 方法，会话列表更新  ELSE  ', obj)
          //相同的更新，不同的增加
          let hasIt = false;
          for (let i = 0; i < that.global.contactsList.length; i++) {
            if (that.global.contactsList[i].lastMsg.from.toLowerCase() == obj.lastMsg.from.toLowerCase()) {
              that.global.contactsList[i] = obj;
              hasIt = true;
            }
          }
          if (!hasIt) {
            console.log("Auth.vue -onUpdateSession- 里面没有，push");
            that.global.contactsList.push(obj);
          }
          console.log('== Contact == onUpdateSession() 方法，会话列表更新  this.global.contactsList  ', this.global.contactsList)
        }
        that.countMsgNum();
      }
    },
    onRoamingMsgs(obj) {
      if (this.global.setLetterList != null) {
        console.log('== Contact == onRoamingMsgs()， 漫游消息 方法  IF', obj)
        this.global.setLetterList.getMsg(obj)
      } else {
        console.log('== Contact == onRoamingMsgs()， 漫游消息 方法  ELSE', obj)
        this.global.letterList.push(obj);
      }
    },
    onOfflineMsgs(obj) {
      if (this.global.setLetterList != null) {
        this.global.setLetterList.getMsg(obj)
        console.log('== Contact == onOfflineMsgs() 方法, 离线消息 IF  ', obj)
      } else {
        console.log('== Contact == onOfflineMsgs() 方法, 离线消息 ELSE ', obj)
        this.global.letterList.push(obj);
      }
    },
    onMsg(obj) {
      if (this.global.setLetterList != null) {
        console.log('== Contact == onMsg(), 收到消息 方法 IF', obj)
        this.global.setLetterList.getMsg(obj)
      } else {
        console.log('== Contact == onMsg(), 收到消息 方法 ELSE', obj)
        this.global.letterList.push(obj);
      }
    },
    countMsgNum() {
      let that = this;
      let num = 0;
      for (let i = 0; i < that.global.contactsList.length; i++) {
        console.log("countMsgNum 方法 第 " +i + "项未读条数:" + that.global.contactsList[i].unread)
        num += that.global.contactsList[i].unread;
      }
      this.global.msgCountGlobal = num;
      if (this.global.setMsgCount != null) {
        this.global.setMsgCount(num);
      }
      console.log("countMsgNum 方法 总的未读条数:" + num);
    }
  }
}
</script>
<style lang="scss">
  /*@import '../assets/style/common.scss';*/
</style>
